import "./App.css";
import Nav from "./components/Nav";
import Routing from "./components/Routing";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Nav />
      <Routing />
      <Footer />
    </>
  );
}

export default App;
